export const clinicalTranslation = {
  'record.translate': 'Translate',
  'record.translationLanguageMenu': 'Translation language',
  'record.translationLanguageTabs': 'Language shown',
  'record.translationLanguageField': 'Language shown for this field',
  'record.translationSavedMark': 'Saved',
  'record.translationBadge': 'This field has a translation',
  'record.translationTitle': 'Clinical note translation',
  'record.translationTranslating': 'Translating…',
  'record.translationDiscard': 'Discard changes',
  'record.translationSourceDirty': 'Save the protocol before translating; the Save button stores the protocol and translation together.',
  'record.translationSwitchBlocked': 'Save or discard this translation before switching language.',
  'record.translationStale': 'The source note changed after this translation was saved.',
  'record.translationEmpty': 'This note has no non-empty text to translate.',
  'record.translationLoadFailed': 'Saved translations could not be loaded.',
  'record.translationGenerateFailed': 'The translation could not be prepared. Try again.',
  'record.translationKeyMissing': 'Add your OpenAI key in account settings before translating.',
  'record.translationSourceChanged': 'The source note changed. Reload it before translating again.',
  'record.translationSaveFailed': 'The translation could not be saved. Try again.',
  'record.translationSaveConflict': 'This translation or its source changed elsewhere. Reload before saving.',
  'record.translationReplaceTitle': 'Replace translation text',
  'record.translationReplaceBody': 'A new AI translation will replace the translation text currently shown.',
  'record.translationReplaceConfirm': 'Replace with new translation',
  'record.translationReplaceCancel': 'Keep current text',
  'record.translationUnsavedIntent': 'Clinical note translation — edits that were never saved',
} as const
